import { shallowMount } from "@vue/test-utils";
import ClienteCA from "@/views/ClienteCA";

describe("ClienteCA component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ClienteCA);
  });

  it("Renders del component ClienteCA", () => {
    expect(wrapper).toBeDefined();
  });
});
